<template>
	<sf-modal-layout size="xl" :title="getMessage_('QWCC001849')" :show="show" :closeModal="close">
		<div class="sf-flex-column h-100">
			<div class="sf-col sf-col-4">
				<sf-card class="p-0 h-100 card_bg">
					<part-mng-popup-search ref="pqPartPopupSearch" :scrId="scrId" />
				</sf-card>
			</div>

			<div class="sf-col sf-col-20">
				<sf-card class="pb-3 border-0 bg-transparent h-100">
					<part-mng-popup-table ref="table" @close="close" @reload="reload" @SendData="sendData" :scrId="scrId" />
				</sf-card>
			</div>
		</div>
	</sf-modal-layout>
</template>

<script>
import { rootComputed, rootMethods } from '@/store/common/helpers';
import { serviceComputed, serviceMethods } from '@qms/comm/commpopup/PartMngPopup/store/helpers';
import PartMngPopupSearch from './Content/Search/PartMngPopupSearch.vue';
import PartMngPopupTable from './Content/Table/PartMngPopupTable.vue';

export default {
	props: {
		scrId: { type: String, default: '' }
	},
	components: { PartMngPopupSearch, PartMngPopupTable },
	data() {
		return {
			show: false
		};
	},
	computed: {
		...rootComputed,
		...serviceComputed
	},
	methods: {
		...rootMethods,
		...serviceMethods,
		open(partNo, cpnyParam) {
			this.show = true;
			this.setStateInit_();
			this.setSearchParam_({ key: 'partNo', value: partNo });
			if (cpnyParam) {
				const { cpnyCd, cpnyNm, isDisabled } = cpnyParam;
				this.setSearchParam_({ key: 'cpnyCd', value: cpnyCd });
				this.setSearchParam_({ key: 'cpnyNm', value: cpnyNm });
				isDisabled && this.setState_({ key: 'isDisabled', value: isDisabled });
			}
			this.reload();
		},
		close() {
			this.show = false;
		},
		reload() {
			this.$refs.pqPartPopupSearch && this.$refs.pqPartPopupSearch.searchList();
		},
		sendData(sendParam) {
			this.$emit('SendData', sendParam);
			this.close();
		}
	}
};
</script>

<style></style>
